import { render, staticRenderFns } from "./Parametros.vue?vue&type=template&id=0143c965&scoped=true&"
import script from "./parametros.js?vue&type=script&lang=js&"
export * from "./parametros.js?vue&type=script&lang=js&"
import style0 from "./Parametros.vue?vue&type=style&index=0&id=0143c965&scoped=true&lang=css&"
import style1 from "./Parametros.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143c965",
  null
  
)

export default component.exports